@import 'styles/mixins';
@import 'styles/variables';

.content {
  display: flex;
  margin-top: 24px;
}

.navigation {
  @include ui-md-semibold;
  margin: 0 10px;
  width: min-content;
}

.sections {
  @include thinScrollbar;
  height: 70vh;
  overflow-y: scroll;
  scroll-behavior: smooth;
  padding-right: 10px;
}

.sectionTitle {
  @include xl-semibold;
  margin-bottom: 24px;
  margin-left: 20px;
}

.divider:not(:last-child) {
  background: var(--neutral-10);
  height: 1px;
  margin: 44px 24px;
}
